import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginTop: 64,
    marginLeft: 32,
    marginRight: 32,
  },
  iframeContainer: {
    width: '100%',
    height: '100vh',
    position: 'relative',
    overflow: 'hidden',
    // paddingTop: '56.25%',
  },
  iframe: {
    width: '100%',
    height: '90%',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    border: 0,
  },
}));
